import { API_BASE_URL, API_BASE_URL_FOR_REPORT } from "./Constant";
import { KEY_NAME } from "./KeyName";
import { dataDisplayRequest } from "./auth_service/AuthServiceHelper";

const cleanParams = (params) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([_, value]) => value !== undefined && value !== null && value !== "",
    ),
  );

/* Service layer class for all API related calls */
export default class AxiosService {
  // constructor() { }

  // getSearchFunder({ expandId, isExpand }) {
  //   const config = {
  //     method: "get",
  //     url: SEARCH_FUNDER_BASE_URL + `/chorusFunders/funder-hierarchy`,
  //     params: cleanParams({
  //       funderId: expandId,
  //       expandId: expandId,
  //       expandIds: [],
  //       isExpand: isExpand,
  //     }),
  //   };
  //   return dataDisplayRequest(config).then((response) => {
  //     return response;
  //   });
  // }

  postPublisherExportReportForOpenAccessOnPubSite(queryData, publisherName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL_FOR_REPORT +
        `/report/generateCsvForPublisherOpenAccessOnPubSite`,
      data: cleanParams({
        // publisher: publisherName,
        category: queryData.category,
        publisher: publisherName,
        email: queryData.email,
        columns: queryData.columns,
        startDate: queryData.startDate,
        endDate: queryData.endDate,
        agencyId: queryData.agencyId,
        format: queryData.format,
        // category: queryData.reportType,
        // email: queryData.email,
        // chorus_Participant: false,
        // funderId: queryData?.filterByMemberId || queryData?.memberId,

        clickedValue: queryData.clickedValue,
        agency: "indicator",
        clickedDateFixed: "Mi8xOC8yMDI2",
        chorus_Participant: false,
      }),
    };

    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  postFunderExportReportForOpenAccessOnPubSite(queryData, publisherName) {
    const config = {
      method: "post",
      url:
        API_BASE_URL_FOR_REPORT +
        `/report/generateCsvForAgencyOpenAccessOnPubSite`,
      data: cleanParams({
        // publisher: publisherName,
        category: queryData.category,
        agency: publisherName,
        clickedValue: queryData.clickedValue,
        email: queryData.email,
        columns: queryData.columns,
        startDate: queryData.startDate,
        endDate: queryData.endDate,
        memberId: queryData.memberId,
        doi: queryData.searchedDoi,
        format: queryData.format,

        chorusMember: false,

        //         {
        //   "category": "string",
        //   "agency": "string",
        //   "email": "string",
        //   "chorusMember": true,
        //   "startDate": "string",
        //   "endDate": "string",
        //   "columns": [
        //     {
        //       "field": "string",
        //       "label": "string"
        //     }
        //   ]
        // }
      }),
    };

    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  /*REPORT FOR ALL THREE*/

  getExportReportForDatasetReport(queryData, shortName, entityName) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/dataset-report`,
      params: cleanParams({
        datasetReport:
          entityName === KEY_NAME.FUNDER
            ? "agency"
            : entityName === KEY_NAME.PUBLISHER
              ? "publisher"
              : "institution",
        name: shortName.toLowerCase(),
        email: queryData.email,
        chorus_Participant: false,
        isFormatted: true,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getExportReportForRetractionReport(queryData, shortName, entityName) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/retraction-report`,
      params: cleanParams({
        type:
          entityName === KEY_NAME.FUNDER
            ? "agency"
            : entityName === KEY_NAME.PUBLISHER
              ? "publisher"
              : "institution",
        name: shortName.toLowerCase(),
        email: queryData.email,
        chorus_Participant: false,
      }),
    };
    // console.log("config for Retraction DOI Report:", config.params);
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getReportAccessibility(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/reportAccessibility`,
      params: cleanParams({
        doi: queryData.doi,
        agency: queryData.agency,
        npa: queryData.npa,
        lnw: queryData.lnw,
        email: queryData.email,
        comment: queryData.comment,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getExportReportForCorrespondenceReport(
    queryData,
    shortName,
    fullName,
    entityName,
  ) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/correspondence-report`,
      params: cleanParams({
        type:
          entityName === KEY_NAME.FUNDER
            ? "agency"
            : entityName === KEY_NAME.PUBLISHER
              ? "publisher"
              : "institution",
        name: fullName,
        ReportName: shortName === "JST" ? shortName.toLowerCase() : shortName,
        email: queryData.email,
        chorus_Participant: false,
        startDate: queryData?.startDate,
        endDate: queryData?.endDate,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getMailAdhocReport(queryData, shortName, entityName) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/mailAdhocReport`,
      params: cleanParams({
        email: queryData.email,
        agency: shortName.toLowerCase(),
        fileType: queryData.fileType,
        dashboardtype: queryData.dashboardType, //agency or publishers
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  /*FUNDER API*/

  getFundersMetaInfo(memberId, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publicationCountWithSummary`,
      params: cleanParams({ funderName: funderName, memberId: memberId }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFundersList(shortCode = "", isMask = false) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/funders`,
      params: cleanParams({
        page: 1,
        size: 40,
        shortCode: shortCode?.toLocaleUpperCase(),
        isMask: isMask,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFundersTimeSeries(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/time-series?funderName=${funderName}`,
      params: cleanParams({
        publisherFilter: queryData.publisherFilter,
        memberId: queryData.memberId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderReuseLicense(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/reuse-license`,
      params: cleanParams({
        funderName: funderName,
        reuseType: queryData.reuseType,
        publisherFilter: queryData.publisherFilter,
        memberId: queryData.memberId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFundersTimeSeriesAll(funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/time-series-all?funderName=${funderName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderDatasetTypeChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/dataset-types`,
      params: cleanParams({
        agencyId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getFunderDatasetRepositoriesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/dataset-repositories`,
      params: cleanParams({
        agencyId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderDatasetLicenseTypesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/dataset-license-types`,
      params: cleanParams({
        agencyId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherReport(queryData, funderName, signal) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publishers/report`,
      params: cleanParams({
        funderName,
        search: queryData.entityContentSearch,
        page: queryData.page,
        size: queryData.size,
        sortBy: queryData.sortKey,
        sortOrder: queryData.sortOrder,
        publisherFilter: queryData.publisherFilter,
        memberId: queryData.filterByMemberId || queryData?.memberId,
      }),
      signal,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  // getPublisherReport(queryData, funderName) {
  //   const config = {
  //     method: "get",
  //     url:
  //       API_BASE_URL +
  //       `/publishers/report?funderName=${funderName}&search=${queryData.search}&page=${queryData.page}&size=${queryData.size}&sortBy=${queryData.sortKey}&sortOrder=${queryData.sortOrder}&publisherFilter=${queryData.publisherFilter}&memberId=${queryData.memberId}`,
  //   };
  //   return dataDisplayRequest(config).then((response) => {
  //     return response;
  //   });
  // }

  getPublicationDetails(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publicationDetails`,
      params: cleanParams({
        funderName,
        search: queryData.entityDetailsSearch,
        page: queryData.page,
        size: queryData.size,
        sortBy: queryData.sortKey,
        sortOrder: queryData.sortOrder,
        filter: queryData.filter,
        publisherFilter: queryData.publisherFilter,
        memberId: queryData.filterByMemberId || queryData?.memberId,
        clickedValue: queryData.clickedValue,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  // getPublicationDetails(queryData, funderName) {
  //   const config = {
  //     method: "get",
  //     url:
  //       API_BASE_URL +
  //       `/publicationDetails?funderName=${funderName}&search=${queryData.search}&page=${queryData.page}&size=${queryData.size}&sortBy=${queryData.sortKey}&sortOrder=${queryData.sortOrder}&filter=${queryData.filter}&publisherFilter=${queryData.publisherFilter}&memberId=${queryData.memberId}`,
  //   };
  //   return dataDisplayRequest(config).then((response) => {
  //     return response;
  //   });
  // }

  getPublisherCount(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherCount`,
      params: cleanParams({
        funderName,
        memberId: queryData?.filterByMemberId || queryData?.memberId,
        publisherFilter: queryData.publisherFilter,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  // getPublisherCount(queryData, funderName) {
  //   const config = {
  //     method: "get",
  //     url:
  //       API_BASE_URL +
  //       `/publisherCount?funderName=${funderName}&memberId=${queryData.memberId}`,
  //   };
  //   return dataDisplayRequest(config).then((response) => {
  //     return response;
  //   });
  // }

  getFunderOkCounts(queryData, funderName) {
    const params = new URLSearchParams({
      funderName,
      ...queryData,
    }).toString();

    const config = {
      method: "get",
      url: API_BASE_URL + `/ok-counts?${params}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherForHorizontalBarChart(sortBy, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publishers?funderName=${funderName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLookupPublicationData(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/lookupFunderCrossref`,
      params: cleanParams({
        funderName,
        funderId: queryData.funderId,
        searchType: queryData.searchType,
        query: queryData.searchValue,
        page: queryData.page,
        size: queryData.size,
        includeDescendants: queryData.includeDescendants,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublishersSuggestions(queryData, funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/funder-hierarchy/suggest`,
      params: cleanParams({
        funderName: funderName,
        searchText: queryData.searchValue,
        size: 10,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getChorusMembersList(funderName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/chorus-members?funderName=${funderName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  // getFunderExportReport(funderName) {
  //   const config = {
  //     method: "get",
  //     url: API_BASE_URL + `/publications/excel?funderName=${funderName}`,
  //   };
  //   return dataDisplayRequest(config).then((response) => {
  //     return response;
  //   });
  // }
  getFunderExportReportForOpenAccessOnPubSite(queryData, funderName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL_FOR_REPORT +
        `/report/generateCsvForAgencyOpenAccessOnPubSite`,
      params: cleanParams({
        agency: funderName,
        category: queryData.reportType,
        email: queryData.email,
        chorus_Participant: false,
        format: queryData.format,
        startDate: queryData?.startDate,
        endDate: queryData?.endDate,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderExportReport(funderName) {
    const config = {
      method: "get",
      url: `${API_BASE_URL}/publications/excel`,
      params: { funderName },
      responseType: "blob",
    };

    return dataDisplayRequest(config);
  }

  /*PUBLISHER API */

  getPublisherMetaInfo(funderId, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/funderCountWithSummary`,
      params: cleanParams({ publisherName: publisherName, funderId: funderId }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublishersList(shortCode = "", isMask = false) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/publishers`,
      params: cleanParams({
        page: 1,
        size: 40,
        shortCode: shortCode?.toLocaleUpperCase(),
        isMask: isMask,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherOkCounts(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/ok-counts`,
      params: cleanParams({
        publisherName,
        funderFilter: queryData.publisherFilter,
        funderId: queryData?.filterByMemberId || queryData?.memberId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherTimeSeries(queryData, publisherName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/publisherApi/time-series?publisherName=${publisherName}`,
      params: cleanParams({
        funderFilter: queryData.publisherFilter,
        funderId: queryData.memberId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  //For Other Matrics tab
  getPublisherTimeSeriesAll(publisherName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/publisherApi/time-series-all?publisherName=${publisherName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherReuseLicense(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/reuse-license`,
      params: cleanParams({
        publisherName: publisherName,
        reuseType: queryData.reuseType,
        funderFilter: queryData.publisherFilter,
        funderId: queryData.memberId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFundersForHorizontalBarChart(sortBy, publisherName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL + `/publisherApi/funders?publisherName=${publisherName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherDatasetTypeChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/dataset-types`,
      params: cleanParams({
        memberId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getPublisherDatasetRepositoriesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/dataset-repositories`,
      params: cleanParams({
        memberId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherDatasetLicenseTypesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/dataset-license-types`,
      params: cleanParams({
        memberId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFundersReport(queryData, publisherName, signal) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/publisherApi/funders/report?publisherName=${publisherName}&search=${queryData.entityContentSearch}&page=${queryData.page}&size=${queryData.size}&sortBy=${queryData.sortKey}&sortOrder=${queryData.sortOrder}`,
      params: cleanParams({
        // publisherName,
        funderFilter: queryData.publisherFilter,
        funderId: queryData?.filterByMemberId || queryData?.memberId,
      }),
      signal,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderDetails(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/funderDetails`,
      params: cleanParams({
        publisherName,
        funderId:
          queryData.agencyId ||
          queryData.filterByMemberId ||
          queryData.memberId,
        filter: queryData.filter,
        funderFilter: queryData.publisherFilter,
        search: queryData.entityDetailsSearch,
        page: queryData.page,
        size: queryData.size,
        sortBy: queryData.sortKey,
        sortOrder: queryData.sortOrder,
        clickedValue: queryData.clickedValue,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderCount(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/funderCount`,
      params: cleanParams({
        publisherName,
        funderId: queryData?.filterByMemberId || queryData?.memberId,
        funderFilter: queryData.publisherFilter,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherExportReportForOpenAccessOnPubSite(queryData, publisherName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL_FOR_REPORT +
        `/report/generateCsvForPublisherOpenAccessOnPubSite`,
      params: cleanParams({
        publisher: publisherName,
        category: queryData.reportType,
        email: queryData.email,
        chorus_Participant: false,
        funderId: queryData?.filterByMemberId || queryData?.memberId,
        format: queryData.format,
        startDate: queryData?.startDate,
        endDate: queryData?.endDate,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherExportReportForFunderContentReport(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/publishers/agency-table/csv`,
      params: cleanParams({
        publisher: publisherName,
        email: queryData.email,
        chorus_Participant: false,
        startDate: queryData?.startDate,
        endDate: queryData?.endDate,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getPublisherExportReportForAgencies(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL_FOR_REPORT + `/report/publishers/agencies/csv`,
      params: cleanParams({
        publisher: publisherName,
        agency: queryData.agency,
        category: queryData.category,
        subcategory: queryData.subcategory,
        clickedValue: queryData.clickedValue,
        id: queryData.id,
        email: queryData.email,
        // columns: queryData.columns,

        // agency: "indicator",
        // clickedDateFixed: "Mi8xOC8yMDI2",
        // chorus_Participant: false,
      }),
    };

    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderHierarchySuggestions(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/funder-hierarchy/suggest`,
      params: cleanParams({
        publisherName: publisherName,
        searchText: queryData.searchValue,
        size: 10,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getFunderHierarchy(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/funder-hierarchy`,
      params: cleanParams({
        funderId: queryData.doi,
        expandId: queryData.expandId,
        isExpand: queryData.isExpand,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getLookupFunder(queryData, publisherName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/publisherApi/lookupFunderCrossref`,
      params: cleanParams({
        publisherName: publisherName,
        funderId: queryData.funderId,
        searchType: queryData.searchType,
        query: queryData.searchValue,
        funderId: queryData.doi,
        page: queryData.page,
        size: queryData.size,
        includeDescendants: queryData.includeDescendants,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getChorusFunderList(publisherName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL +
        `/publisherApi/chorus-funders?publisherName=${publisherName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  /*INSTITUTION API */

  getInstitutionsList(shortCode = "", isMask = false) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/institutionApi/institutions`,
      params: cleanParams({
        page: 1,
        size: 40,
        shortCode: shortCode?.toLocaleUpperCase(),
        isMask: isMask,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getInstitutionDatasetTypeChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/institutionApi/dataset-types`,
      params: cleanParams({
        institutionId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
  getInstitutionDatasetRepositoriesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/institutionApi/dataset-repositories`,
      params: cleanParams({
        institutionId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getInstitutionDatasetLicenseTypesChart(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/institutionApi/dataset-license-types`,
      params: cleanParams({
        institutionId: queryData.entityId,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getInstitutionRorId(shortName) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/institutionApi/institutionROR/${shortName}`,
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getInstitutionExportReportForOpenAccessOnPubSite(queryData, institutionName) {
    const config = {
      method: "get",
      url:
        API_BASE_URL_FOR_REPORT +
        `/report/generateCsvForInstitutionOpenAccessOnPubSite`,
      params: cleanParams({
        institute: institutionName,
        category: queryData.reportType,
        email: queryData.email,
        chorus_Participant: false,
        format: queryData.format,
        startDate: queryData?.startDate,
        endDate: queryData?.endDate,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }

  getCitation(queryData) {
    const config = {
      method: "get",
      url: API_BASE_URL + `/citationApi/citation`,
      params: cleanParams({
        doi: queryData.doi,
        citationFormat: queryData.citationFormat,
      }),
    };
    return dataDisplayRequest(config).then((response) => {
      return response;
    });
  }
}
